// @flow
import './default-bundle';

import MobileNav from '@components/menus/MobileNav';

ReactOnRails.register({
  MobileNav
});
